import { querystringConf } from './querystringConf';

export enum StoredKey {
	LAST_MESSAGE_TIMESTAMP = 'last_message_timestamp',
	CHAT_IS_OPEN = 'chat_isOpen',
	LOCALE = 'locale',
}

const parseKey = (key: StoredKey | string, m3_ep: string) => {
	if (key.startsWith(`enuan__${m3_ep}`)) return key;
	return `enuan__${m3_ep}__${key}`;
};

const set = (
	key: StoredKey | string,
	value: any,
	forceSave: boolean = false,
	m3_ep: string,
) => {
	const isLocalStorageDisabled = querystringConf('DISABLE_LOCAL_STORAGE');
	if ((!isLocalStorageDisabled || forceSave) && typeof value !== 'undefined') {
		window.localStorage.setItem(parseKey(key, m3_ep), JSON.stringify(value));
	}
};

const get = <T = any>(key: StoredKey | string, m3_ep: string) => {
	const val = window.localStorage.getItem(parseKey(key, m3_ep)) ?? undefined;
	try {
		const value = JSON.parse(val ?? '');
		if (value === 'undefined' || value === '') {
			return undefined;
		} else {
			return value as T;
		}
	} catch (e) {
		return undefined;
	}
};

export const updateStorageTimestamp = (timestamp: string, m3_ep: string) => {
	const lastReadMessage: string =
		get(StoredKey.LAST_MESSAGE_TIMESTAMP, m3_ep) ?? '';
	if (timestamp <= lastReadMessage) return lastReadMessage;

	set(StoredKey.LAST_MESSAGE_TIMESTAMP, timestamp, true, m3_ep);
	return timestamp;
};

const unset = (key: StoredKey | string, m3_ep: string) => {
	window.localStorage.removeItem(parseKey(key, m3_ep));
};

export const enuanLocalStorage = { parseKey, set, get, unset };
export default enuanLocalStorage;
